;(function() {

    const mapId = ('#ymap');

    function init() {

        if (mapId.length > 0) {
            const map = new ymaps.Map('ymap', {
                center: [55.705483, 37.594962],
                zoom: 15,
                controls: ['fullscreenControl', 'zoomControl', 'trafficControl'],
                behaviors: ['drag', 'dblClickZoom', 'multiTouch']
            }, );

            const placemark1 = new ymaps.Placemark([55.705483, 37.594962], {
                hintContent: 'Volkswagen'
            }, {
                iconLayout: 'default#image',
                iconImageHref: '/dist/img/content/pin.png',
                iconImageSize: [62, 80],
                iconImageOffset: [-25, -70],
            });

            map.geoObjects
                .add(placemark1)
        }
    }

    ymaps.ready(init);
})();
